module.exports = __webpack_public_path__ + "static/media/Alana.65505b41.jpg";